import { CreditCard } from "lucide-react";

export default function BillingUsageTab({ billing }) {
  const usageItems = [
    {
      label: "API Requests",
      used: billing.usage?.apiRequests?.used?.toLocaleString() || "0",
      limit: billing.usage?.apiRequests?.limit?.toLocaleString() || "0",
      suffix: "per month"
    },
    {
      label: "Team Members",
      used: billing.usage?.teamMembers?.used || "0",
      limit: billing.usage?.teamMembers?.limit || "0",
      suffix: ""
    },
    {
      label: "Connected Integrations",
      used: billing.usage?.connectedIntegrations?.used || "0",
      limit: billing.usage?.connectedIntegrations?.limit || "0",
      suffix: ""
    }
  ];

  return (
    <div className="space-y-6">
      {/* Current Plan */}
      <div className="bg-white rounded-2xl border border-gray-200 p-6">
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-900">Current Plan</h3>
          <p className="text-sm text-gray-600">
            Manage your subscription and billing information
          </p>
        </div>

        <div className="border border-gray-200 rounded-xl p-6">
          <div className="flex items-start justify-between mb-4">
            <div>
              <span className="inline-block px-3 py-1 text-sm font-medium text-green-700 bg-green-100 rounded-md mb-3">
                {billing.plan}
              </span>
              <p className="text-3xl font-bold text-gray-900">
                {billing.price}
              </p>
              <p className="text-sm text-gray-500">{billing.billingCycle}</p>
            </div>
            <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
              Change Plan
            </button>
          </div>

          <div className="border-t border-gray-200 pt-4 space-y-3">
            {usageItems.map((item, index) => (
              <div key={index} className="flex items-center justify-between">
                <span className="text-sm text-gray-600">{item.label}</span>
                <span className="text-sm font-medium text-gray-900">
                  {item.used} / {item.limit} {item.suffix}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Payment Method */}
      <div className="bg-white rounded-2xl border border-gray-200 p-6">
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-900">
            Payment Method
          </h3>
          <p className="text-sm text-gray-600">
            Update your payment information
          </p>
        </div>

        <div className="border border-gray-200 rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <CreditCard className="w-6 h-6 text-green-600" />
              </div>
              <div>
                <p className="font-medium text-gray-900">
                  {billing.paymentMethod?.cardNumber || "•••• •••• •••• ••••"}
                </p>
                <p className="text-sm text-gray-500">
                  Expires {billing.paymentMethod?.expiryDate || "N/A"}
                </p>
              </div>
            </div>
            <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
